import { j as v } from "./jsx-runtime-3tyXYecC.mjs";
import { _ as y } from "./composeRefs-YONvD-rx.mjs";
import { useRef as F } from "react";
import { S as i } from "./selectable-box-BqzFKtVw.mjs";
import { g as j } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as U } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as A } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { c as D } from "./combine-function-calls-C5qD-ZYI.mjs";
const H = window.jQuery ? $.__("Please select an option to continue.") : "Please select an option to continue.";
function k({
  apiRef: l,
  ariaDescribedby: u,
  control: p,
  defaultValue: f = !1,
  errorMessageId: t,
  isDisabled: n,
  inputId: m,
  name: s,
  onBlur: g,
  onChange: a,
  required: o,
  shouldUnregister: R,
  status: C,
  validate: b,
  ...d
}) {
  var c;
  const { field: x, fieldState: r } = U({
    control: p,
    defaultValue: f,
    name: s,
    rules: A(
      {
        required: o === !0 ? {
          message: H,
          value: !!o
        } : o,
        validate: b
      },
      n
    ),
    shouldUnregister: R
  }), { onBlur: S, onChange: h, ref: B, value: E } = x, e = F(E), _ = () => {
    e.current = !e.current, h(e.current), typeof a == "function" && a(e.current);
  };
  return /* @__PURE__ */ v.jsx(
    i,
    {
      ...d,
      apiRef: y(B, l),
      ariaDescribedby: j(r.error ? t : void 0, u),
      errorMessage: t || (c = r.error) == null ? void 0 : c.message,
      inputId: m,
      isChecked: e.current,
      isDisabled: n,
      name: s,
      onBlur: D(S, g),
      onChange: _,
      status: r.error ? "error" : C,
      type: "checkbox"
    }
  );
}
k.UpperContent = i.UpperContent;
export {
  k as S
};
//# sourceMappingURL=selectable-box-rhf-hL95Vxjo.mjs.map
